<template>
  <div class="user-info-record-dialog">
    <div class="dialog-content">
      <div class="dialog-top">
        <p class="dialog-top-title">信息记录</p>
        <button
          class="dialog-top-close"
          :style="{
            backgroundImage: `url(${require('@imgs/close-card.png')})`,
          }"
          @click="onCancelClick"
        ></button>
      </div>
      <div class="dialog-middle">
        <div class="record-items">
          <div class="record-item">
            <label>用户: </label>
            <span class="record-value">{{ user.trueName }}</span>
          </div>
          <div class="record-item">
            <dialog-radio title="AR" v-model="recordData.ar" :options="['有', '无']"></dialog-radio>
          </div>
          <div class="record-item">
            <label for="adenoids">腺样体: </label>
            <input type="text" id="adenoids" v-model="recordData.adenoids" :maxlength="3" placeholder="最多3个字">
          </div>
          <div class="record-item">
            <label for="tonsil">扁桃体: </label>
            <input type="text" id="tonsil" v-model="recordData.tonsil" :maxlength="6" placeholder="最多6个字">
          </div>
          <div class="record-item">
            <dialog-radio title="咽喉反流" v-model="recordData.throatReflux" :options="['有', '无']"></dialog-radio>
          </div>
          <div class="record-item">
            <dialog-radio title="睡眠张口" v-model="recordData.sleepOpenMouth" :options="['有', '无']"></dialog-radio>
          </div>
          <div class="record-item">
            <dialog-radio title="过敏原" v-model="recordData.allergen" :options="['户尘螨', '屋尘螨']" multiple></dialog-radio>
          </div>
        </div>
        <div class="hint-text">提示: 以上内容会展示在睡眠报告中。</div>
      </div>
      <div class="dialog-bottom">
        <button class="dialog-bottom-cancel" @click="onCancelClick">取消</button>
        <button class="dialog-bottom-confirm" @click="onSaveClick">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import DialogRadio from "./dialog-radio.vue";
export default {
  components: {
    DialogRadio,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      recordData: {
        ar: '',
        adenoids: '',
        tonsil: '',
        throatReflux: '',
        sleepOpenMouth: '',
        allergen: '',
      },
      userDetail: {},
    };
  },
  watch: {
    user: {
      handler(newVal) {
        this.getUserDetail();
      },
      immediate: true
    },
  },
  methods: {
    onCancelClick() {
      this.$emit('close');
    },
    onSaveClick() {
      this.userEditRequest()
    },

    async getUserDetail() {
      try {
        const params = { id: this.user.id };
        const response = await this.$api.getUserDetail(params);
        this.userDetail = response;
        this.recordData = {
          ar: response.ar || '',
          adenoids: response.adenoids || '',
          tonsil: response.tonsils || '',
          throatReflux: response.throatReflux || '',
          sleepOpenMouth: response.sleepOpenMouth || '',
          allergen: response.allergen || '',
        };
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async userEditRequest() {
      try {
        const params = {
          ...this.userDetail,
          ar: this.recordData.ar,
          tonsils: this.recordData.tonsil,
          adenoids: this.recordData.adenoids,
          throatReflux: this.recordData.throatReflux,
          sleepOpenMouth: this.recordData.sleepOpenMouth,
          allergen: this.recordData.allergen,
        };
        await this.$api.editUser(params);
        this.$toast.showGreen(MSG.userEditSucceed);
        this.$emit('save', this.recordData);
      } catch (error) {
        this.$toast.showRed(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info-record-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .dialog-content {
    background-color: white;
    width: rem(483);
    display: flex;
    flex-direction: column;

    .dialog-top {
      width: 100%;
      height: rem(55);
      border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
      box-sizing: border-box;
      padding: rem(0) rem(24);
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-title {
        color: rgba($color: black, $alpha: 0.85);
        font-size: rem(16);
      }

      &-close {
        width: rem(16);
        height: rem(16);
        background-size: rem(16) rem(16);
        background-repeat: no-repeat;
      }
    }

    .dialog-middle {
      box-sizing: border-box;
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(14);
      line-height: rem(20);
      border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
      width: 100%;
      height: rem(380);
      padding: rem(20) rem(24);
      overflow-y: auto;

      .record-items {
        width: 100%;

        .record-item {
          display: flex;
          align-items: center;
          margin-bottom: rem(15);

          label {
            width: rem(80);
            margin-right: rem(10);
            text-align: right;
            color: rgba($color: black, $alpha: 0.85);
            font-size: rem(14);
          }

          .record-value {
            flex: 1;
          }

          input {
            flex-grow: 1;
            height: rem(24);
            padding: rem(5) rem(10);
            border: 1px solid #e8e8e8;
            border-radius: rem(4);
            font-size: rem(14);

            &:focus {
              border-color: #325fac;
              outline: none;
            }

            &::placeholder {
              color: #bfbfbf;
            }
          }
        }
      }

      .hint-text {
        text-align: center;
        font-size: rem(12);
        color: rgba($color: black, $alpha: 0.45);
        margin-top: rem(20);
      }
    }

    .dialog-bottom {
      width: 100%;
      height: rem(56);
      box-sizing: border-box;
      padding: rem(10) rem(16) 0;
      display: flex;
      justify-content: flex-end;

      &-confirm {
        color: white;
        background-color: #325fac;
        font-size: rem(14);
        border-radius: rem(3);
        width: rem(65);
        height: rem(32);
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        cursor: pointer;
      }

      &-cancel {
        color: rgba($color: #000000, $alpha: 0.65);
        background-color: white;
        font-size: rem(14);
        border-radius: rem(3);
        border: rem(1) solid #e8e8e8;
        width: rem(65);
        height: rem(32);
        margin-right: rem(8);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}
</style> 